import { render, staticRenderFns } from "./certificate-active.vue?vue&type=template&id=e9ff669e&scoped=true"
import script from "./certificate-active.vue?vue&type=script&lang=js"
export * from "./certificate-active.vue?vue&type=script&lang=js"
import style0 from "./certificate-active.vue?vue&type=style&index=0&id=e9ff669e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ff669e",
  null
  
)

export default component.exports